import { TextInput } from '@mgmresorts/mgm-ui';
import React, { useContext } from 'react';

import { useContent } from '../../../../hooks/useContent';
import { MaxLengths } from '../../../../utils/constants';
import { MlifeActivationContext } from '../../MlifeActivationContext';

export function FirstName() {
  const { activationRequest } = useContext(MlifeActivationContext);
  const { getContentByPath } = useContent();

  return (
    <TextInput
      variant='default'
      label={getContentByPath('mlifeActivation.accountSetupSection.fields.firstName.title')}
      id='firstName'
      testId='firstName'
      disabled
      icon='lock'
      className={`identity__field identity__field-firstName`}
      value={activationRequest?.fName ?? ''}
      maxLength={MaxLengths.FirstName}
    />
  );
}

FirstName.displayName = 'FirstNameField';
